import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var WrenchIcon = function WrenchIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "WrenchIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.517 2.47a3.227 3.227 0 0 0-3.151 4.55.73.73 0 0 1-.15.818l-4.558 4.559a.668.668 0 1 0 .945.945l4.559-4.559a.73.73 0 0 1 .818-.149 3.227 3.227 0 0 0 4.55-3.151l-1.588 1.589a1.39 1.39 0 0 1-1.948 0l-.005-.005-1.06-1.061a1.39 1.39 0 0 1 0-1.948l.004-.005zM9.465 1.076a4.7 4.7 0 0 1 2.774.341.732.732 0 0 1 .216 1.184l-2.432 2.431.945.945L13.4 3.545a.73.73 0 0 1 1.183.216 4.69 4.69 0 0 1-5.723 6.393l-4.223 4.222a2.13 2.13 0 1 1-3.013-3.013L5.846 7.14a4.69 4.69 0 0 1 3.62-6.064",
      clipRule: "evenodd"
    })
  }));
};

export { WrenchIcon };
